import api from "@/api";
import { PasswordToken } from "./getPasswordRecoveryToken";

export default async function recoverPassword(
  token: PasswordToken,
  password: string,
  document: string,
): Promise<boolean> {
  await api.post("/api/password/recover", {
    document: document.replace(/[^A-Z0-9]/gi, ""),
    token: token.token,
    password,
  });

  return true;
}
